import { GET_CARRIER_LIST_REQUEST, GET_CARRIER_LIST_SUCCESS, GET_CARRIER_LIST_FAILURE, GET_CARRIER_LIST_RESET, } from "../../actions";
const initialState = {
    CarrierListData: null,
    loading: false,
    error: null,
};
const getCarrierListReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CARRIER_LIST_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, CarrierListData: action.payload });
        case GET_CARRIER_LIST_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, CarrierListData: null, error: null });
        case GET_CARRIER_LIST_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, CarrierListData: null });
        case GET_CARRIER_LIST_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, CarrierListData: null, error: null });
        default:
            return state;
    }
};
export default getCarrierListReducer;
